import { render, staticRenderFns } from "./SpecialtyDistribution.vue?vue&type=template&id=20240494&scoped=true&"
import script from "./SpecialtyDistribution.vue?vue&type=script&lang=ts&"
export * from "./SpecialtyDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20240494",
  null
  
)

export default component.exports